import { useMemo } from "react"
import uniqueId from "lodash/uniqueId"

const useUniqueHtmlId = (prefix = "el") => {
  return useMemo(() => uniqueId(prefix), [prefix])
}
export default useUniqueHtmlId
